class Navigation {
  constructor() {
    this.navigation = document.getElementById('navigation-js');
    this.navigationItems = document.getElementsByClassName(
      'navigation-list__item'
    );
    this.sections = document.getElementsByClassName('module-section');
    this.gradient = document.getElementsByClassName('navigation-gradient')[0];
    this.button = document.getElementsByClassName('navigation-button')[0];
    this.wrapper = document.getElementsByClassName('navigation__wrapper')[0];
    this.hashtag = document.getElementsByClassName('navigation__hashtag')[0];
    this.link = document.getElementsByClassName('navigation__hashtag--link')[0];
    this.sectionOffsets = this.getSectionsOffset();
    this.showNavigation = false;

    console.log(this.navigationItems);

    this.initial();
  }
  initial() {
    this.handleEventListeners();
    this.link.setAttribute('href', 'https://twitter.com/hashtag/infoplus2018');
    this.link.setAttribute('target', '_blank');
  }
  handleEventListeners() {
    document.addEventListener('scroll', () => {
      this.sectionOffsets = this.getSectionsOffset();
      const activeSection = this.getActiveSectionIndex();
      this.handleNavigationItems(activeSection);
    });

    [...this.navigationItems].forEach((item, index) => {
      item.addEventListener('click', event => {
        window.scrollTo({
          top: this.sectionOffsets[index] - 20,
          behavior: 'smooth'
        });
        if (this.showNavigation) {
          this.showMobileMenu();
        }
      });
    });

    this.button.addEventListener('click', () => {
      this.showMobileMenu();
    });
  }
  getActiveSectionIndex() {
    const scrollPosition = window.scrollY;
    const sectionsInVp = this.sectionOffsets.filter(
      offset => offset - scrollPosition >= 0
    );
    return this.sectionOffsets.length - sectionsInVp.length;
  }
  getSectionsOffset() {
    const sectionsOffset = [...this.sections].map(section => {
      return section.offsetTop;
    });
    return sectionsOffset;
  }
  handleNavigationItems(activeSection) {
    [...this.navigationItems].forEach((item, index) => {
      if (activeSection - 1 === index) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }

      if (activeSection - 1 >= this.sections.length - 1) {
        this.navigationItems[this.sections.length - 1].classList.add('active');
      } else {
        this.navigationItems[this.sections.length - 1].classList.remove(
          'active'
        );
      }
    });
  }
  showMobileMenu() {
    if (!this.showNavigation) {
      this.navigation.classList.add('navigation--visible');
      this.button.classList.add('navigation-button--active');
      this.hashtag.classList.add('navigation__hashtag--active');
      // this.wrapper.classList.add('navigation__wrapper--active');
    } else {
      this.navigation.classList.remove('navigation--visible');
      this.button.classList.remove('navigation-button--active');
      this.hashtag.classList.remove('navigation__hashtag--active');
      // this.wrapper.classList.remove('navigation__wrapper--active');
    }
    this.showNavigation = !this.showNavigation;
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/modules/snippets/Navigation.js